import { Injectable } from '@angular/core';
import { ConfigService } from './config/config.service';
import { HttpClient, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { NotificationUser } from '../app.types';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  url: string;
  constructor(private configService: ConfigService, private http: HttpClient) { 
    this.url = `${this.configService.API_URI}/AllowanceNotifications`
  }

  get(){
      return this.http.get<NotificationUser>(this.url);
  }

  post(user: NotificationUser){
      const req = new HttpRequest("POST", this.url, user);
      return this.http.request<boolean>(req)
            .pipe(filter(x => x instanceof HttpResponseBase));
  }
}
